import { asyncGet } from './utils';

export async function getIntegrations() {
  return asyncGet('wallet/integrations');
}
